import React, { useEffect, useState } from 'react';
import { Widget, MasterDetailForm, Row, FormInput, FormTextArea, FormDatePicker } from "@digital/ui";
import { Collapse, Card } from "antd";
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import { editDataConclusaoEtapa, getDadosData, getDadosIdentificacao } from '@app/api/sas/ordemCompra';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
    dadosIdentificacaoState, ordemCompraIdState, stepState, reloadWidgetIdentificacaoState, desabilitarAcoesState, dataLimiteEtapaState
} from '../atoms';
import CurrencyInput from '@app/components/CurrencyInput';
import moment from 'moment';
import { StepsTimeline } from '@app/api/status';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import locale from 'antd/es/date-picker/locale/pt_BR';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { CurrencyInput3 } from '@app/components/CurrencyInput3';
import { Visibility } from '@app/components';

interface Props {
    onCollapse: (e: string | string[]) => void;
}

const WidgetIdentificacaoAditivo = ({ onCollapse }: Props) => {

    const [dadosIdentificacao, setDadosIdentificacao] = useRecoilState(dadosIdentificacaoState);

    const ordemCompraId: string = useRecoilValue(ordemCompraIdState);
    const reloadWidgetIdentificacao = useRecoilValue(reloadWidgetIdentificacaoState);
    const step = useRecoilValue<StepsTimeline>(stepState);
    const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);
    const [, setDataLimiteEtapa] = useRecoilState(dataLimiteEtapaState);

    const [datas, setDatas] = useState({ dataInicio: undefined, dataLimite: undefined });
    const [spanValue, setSpanValue] = useState<any>(2);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    // const [sumarioData, setSumarioData] = useState<DadosAbaSumario | undefined>();

    const [dataConclusaoEtapa, setDataConclusaoEtapa] = useState<Date | undefined>(undefined);

    const setWidth = () => {
        setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', setWidth);

    useEffect(() => {
        // console.log('setDataConclusaoEtapa', step);

        if (isObjNotEmpty(step) && 'dataRealConclusao' in step) {
            const isAlt = !dataConclusaoEtapa || dataConclusaoEtapa && dataConclusaoEtapa != step.dataRealConclusao;
            setDataConclusaoEtapa(undefined);
            if (isAlt) {
                setDataConclusaoEtapa(step.dataRealConclusao);
            }
        } else {
            setDataConclusaoEtapa(undefined);
        }
    }, [step]);

    useEffect(() => {
        if (hasPermission(["SAS_EXIBIR_TIMELINE"])) {
            if (screenWidth <= 720) {
                setSpanValue(6);
            } else {
                setSpanValue(3);
            }
        }
    }, [screenWidth]);

    useEffect(() => {
        getDadosIdentificacao(ordemCompraId)
            .then(data => {
                if (data) {
                    setDadosIdentificacao(data);
                }
            });

        // getSumario("null", ordemCompraId)
        //     .then(data => {
        //         if (data) {
        //             setSumarioData(data);
        //         }
        //     });

    }, [ordemCompraId, datas]);

    useEffect(() => {
        if (ordemCompraId && isObjNotEmpty(step)) {
            getDadosData(ordemCompraId, step.ordemCompraFluxoProcessoId, step.ordemCompraRodadaNegociacaoId)
                .then((data: any) => {
                    if (data) {
                        setDatas({ ...datas, dataInicio: data.dataInicio, dataLimite: data.dataLimite });
                        setDataLimiteEtapa(data.dataLimite);
                    }
                });
        }
    }, [ordemCompraId, step, reloadWidgetIdentificacao]);

    const handleEditDataConclusaoEtapa = (value: Date) => {
        setDataConclusaoEtapa(value);
        editDataConclusaoEtapa({
            ordemCompraId,
            ordemCompraFluxoProcessoId: step.ordemCompraFluxoProcessoId,
            ordemCompraRodadaNegociacaoId: step.ordemCompraRodadaNegociacaoId,
            dataConclusaoEtapa: value
        });
    };

    return (
        <>
            <Collapse bordered={false} onChange={(e) => onCollapse(e)} >
                <Collapse.Panel key='identificacao'
                    header={`Identificação ${dadosIdentificacao.numero ? " - OC " + dadosIdentificacao.numero : ""}`}
                >
                    <MasterDetailForm initialValues={{ ...dadosIdentificacao }}>
                        {dadosIdentificacao && (
                            <Widget>
                                <Row>
                                    <Visibility visible={'numeroAnterior' in dadosIdentificacao}>
                                        <FormInput
                                            name="numeroAnterior"
                                            label="Ordem de Compra Totvs Anterior"
                                            disabled
                                            span={spanValue}
                                        />
                                    </Visibility>
                                    <FormInput
                                        name="numero"
                                        label="Ordem de Compra Totvs"
                                        disabled
                                        span={spanValue}
                                    />
                                    <FormInput
                                        name="contrato"
                                        label="Nº do Contrato"
                                        disabled
                                        span={spanValue}
                                    />
                                    <Visibility visible={'valorAditivoAnterior' in dadosIdentificacao}>
                                        <CurrencyInput
                                            name="valorAditivoAnterior"
                                            label="Valor Aditivo Anterior"
                                            disabled
                                            span={spanValue}
                                        // value={"R$ " + formatRealFromBackend(sumarioData.valorAditivo || "")}
                                        />
                                    </Visibility>
                                    <CurrencyInput
                                        name="valorAditivo"
                                        label="Valor Aditivo"
                                        disabled
                                        span={spanValue}
                                    // value={"R$ " + formatRealFromBackend(sumarioData.valorAditivo || "")}
                                    />
                                    <CurrencyInput3
                                        name="valorTotalContratacao"
                                        label="Valor Total da Contratação"
                                        disabled
                                        span={spanValue}
                                    // value={"R$ " + formatRealFromBackend(sumarioData.novoValorFinal || "")}
                                    />
                                </Row>
                                {!hasPermissionPerfil([EGuidPerfilAcesso.FornecedorSAS]) && (
                                    <Row>
                                        <FormTextArea
                                            id="mrn-textarea-objetoASerContratado"
                                            name="objeto"
                                            label="Objeto a Ser Contratado"
                                            disabled
                                            span={12}
                                            rows={3}
                                            maxLength={4000}
                                        />
                                    </Row>
                                )}
                            </Widget>
                        )}
                    </MasterDetailForm>
                </Collapse.Panel>
            </Collapse>

            <Card>
                <MasterDetailForm
                    key={`form_dataConclusaoEtapa`}
                    initialValues={dadosIdentificacao}
                >
                    <Row>
                        <FormDatePicker
                            name='dataInicio'
                            value={datas.dataInicio ? moment(datas.dataInicio) : undefined}
                            format="DD/MM/YYYY"
                            disabled
                            span={spanValue}
                            label="Data Início Etapa"
                        />
                        <FormDatePicker
                            name='dataLimite'
                            value={datas.dataLimite ? moment(datas.dataLimite) : undefined}
                            format="DD/MM/YYYY"
                            disabled
                            span={spanValue}
                            label="Data Limite Etapa (Previsto)"
                        />
                        <FormDatePicker
                            name='dataRealConclusao'
                            label='Data Real de Conclusão da Etapa'
                            format="DD/MM/YYYY"
                            span={spanValue}
                            onChange={e => e && handleEditDataConclusaoEtapa(e.toDate())}
                            locale={locale}
                            allowClear
                            disabled={
                                (
                                    isObjNotEmpty(step) && 'fluxoEtapaId' in step
                                    && [
                                        EGuidFluxoProcessoEtapa.ElaboracaoaprovacaoRH,
                                        EGuidFluxoProcessoEtapa.GerarContratoPCSTotvs,
                                        EGuidFluxoProcessoEtapa.ConsolidacaoAnexosFinais,
                                        EGuidFluxoProcessoEtapa.Assinaturacontrato,
                                        EGuidFluxoProcessoEtapa.HandoverContrato,
                                        EGuidFluxoProcessoEtapa.EnviaCartaAgradecimento,
                                        EGuidFluxoProcessoEtapa.ConclusaoDoProcessoStep
                                    ].toString().includes(step.fluxoEtapaId)
                                ) || desabilitarAcoes
                            }
                            value={dataConclusaoEtapa ? moment(dataConclusaoEtapa) : undefined}
                        />
                    </Row>
                </MasterDetailForm>
            </Card>

        </>
    );
};

export default WidgetIdentificacaoAditivo;